import classNames from "classnames";
import React from "react";

import styles from "./Button.module.css";

type PropTypes = {
  renderAs: "a" | "button";
  href?: string;
  className?: string;
  onClick?: React.MouseEventHandler;
  children: React.ReactNode;
};

const Button = React.forwardRef<HTMLAnchorElement | HTMLButtonElement, PropTypes>(
  ({ href, children, className, onClick, renderAs = "button" }, ref) => {
    if (renderAs === "a") {
      return (
        <a
          ref={ref as React.ForwardedRef<HTMLAnchorElement>}
          href={href}
          className={classNames(styles.button, className)}
          onClick={onClick}
        >
          {children}
        </a>
      );
    }
    return (
      <button
        ref={ref as React.ForwardedRef<HTMLButtonElement>}
        className={classNames(styles.button, className)}
        onClick={onClick}
      >
        {children}
      </button>
    );
  }
);
Button.displayName = "Button";

export default Button;
